import { isProd, isStaging } from "app/constants/env";

export type RouteTrackingEnvironment = "local" | "staging" | "production";
export type IdoFunnelEventName = "wallet_connect_success" | "sale_success";

export type RouteTrackingConversionEvent = {
  funnelEvent: IdoFunnelEventName;
  eventId: string;
  pixelId?: string;
  currency?: "USD";
  includeValue?: boolean;
};

type RouteTrackingRuleBase = {
  id: string;
  enabled: boolean;
  activeFrom?: string;
  activeUntil: string;
  targets: RouteTrackingTarget[];
  conversionEvents?: RouteTrackingConversionEvent[];
};

export type RouteTrackingTarget =
  | {
      type: "ido";
      ids: string[];
    }
  | {
      type: "quest";
      ids: string[];
    }
  | {
      type: "build_karma";
    };

export type RouteTrackingRule =
  | (RouteTrackingRuleBase & {
      provider: "x";
      pixelId: string;
    })
  | (RouteTrackingRuleBase & {
      provider: "meta";
      pixelId?: string;
    });

export const getRouteTrackingEnvironment = (): RouteTrackingEnvironment => {
  if (isProd()) {
    return "production";
  }

  if (isStaging()) {
    return "staging";
  }

  return "local";
};

const CEREBREE_META_PIXEL_ID = "1069589978839684";

export const routeTrackingConfig: Record<
  RouteTrackingEnvironment,
  RouteTrackingRule[]
> = {
  local: [],
  staging: [
    {
      id: "x-r0tux-ido-build-karma-staging",
      provider: "x",
      pixelId: "r0tux",
      enabled: true,
      activeFrom: "2026-06-06T14:00:12.000Z",
      activeUntil: "2026-06-20T14:00:12.000Z",
      targets: [
        { type: "ido", ids: ["6a2069a39436f7876e97df6c"] },
        { type: "build_karma" },
      ],
      conversionEvents: [
        { funnelEvent: "wallet_connect_success", eventId: "tw-r0tux-rcvwy" },
        {
          funnelEvent: "sale_success",
          eventId: "tw-r0tux-rcvwz",
          currency: "USD",
          includeValue: true,
        },
      ],
    },
    {
      id: "meta-cerebree-ido-staging",
      provider: "meta",
      pixelId: CEREBREE_META_PIXEL_ID,
      enabled: true,
      activeFrom: "2026-06-06T14:00:12.000Z",
      activeUntil: "2026-06-20T14:00:12.000Z",
      targets: [{ type: "ido", ids: ["6a2069a39436f7876e97df6c"] }],
      conversionEvents: [
        { funnelEvent: "wallet_connect_success", eventId: "Lead" },
        {
          funnelEvent: "sale_success",
          eventId: "Purchase",
          currency: "USD",
          includeValue: true,
        },
      ],
    },
  ],
  production: [
    {
      id: "x-r0tux-ido-build-karma-production",
      provider: "x",
      pixelId: "r0tux",
      enabled: true,
      activeFrom: "2026-06-06T14:00:12.000Z",
      activeUntil: "2026-06-20T14:00:12.000Z",
      targets: [
        { type: "ido", ids: ["6a2069a39436f7876e97df6c"] },
        { type: "build_karma" },
      ],
      conversionEvents: [
        { funnelEvent: "wallet_connect_success", eventId: "tw-r0tux-rcvwy" },
        {
          funnelEvent: "sale_success",
          eventId: "tw-r0tux-rcvwz",
          currency: "USD",
          includeValue: true,
        },
      ],
    },
    {
      id: "meta-cerebree-ido-production",
      provider: "meta",
      pixelId: CEREBREE_META_PIXEL_ID,
      enabled: true,
      activeFrom: "2026-06-06T14:00:12.000Z",
      activeUntil: "2026-06-20T14:00:12.000Z",
      targets: [{ type: "ido", ids: ["6a2069a39436f7876e97df6c"] }],
      conversionEvents: [
        { funnelEvent: "wallet_connect_success", eventId: "Lead" },
        {
          funnelEvent: "sale_success",
          eventId: "Purchase",
          currency: "USD",
          includeValue: true,
        },
      ],
    },
  ],
};
